import React, { useState, useEffect, useRef } from 'react'
import { Link as ReactLink } from 'react-router-dom'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import styles from './web.module.css'

export default function Web() {

    const [show, setShow] = useState(true)
    const [showBox, setShowBox] = useState(false)
    const ref = useRef(null)
    
    const setScroll = () => {
        if(ref.current.getBoundingClientRect().y < -400) {
            return
        }
        if(ref.current.getBoundingClientRect().y > 0) {
            setShow(false)
            return
        }
        setShow(true)
    }
  
    // useEffect(() => {
    //     window.addEventListener("scroll", setScroll)
    //     return () => {
    //         window.removeEventListener("scroll", setScroll)
    //     }
    // }, [])

    const downloadBtnClick = (e) => {
        if (showBox) setShowBox(false)
        else setShowBox(true)
    }

    const mouseOverText = (e) => {
        e.target.style.textShadow = '0 0 10px #fff,0 0 20px #fff,0 0 40px #fff'
    }

    const mouseOutText = (e) => {
        e.target.style.textShadow = ''
    }

    const mouseOverBtn = (e) => {
        e.target.style.fontWeight = 'bold'
        e.target.style.boxShadow = '0 0 10px 0 #3498db inset, 0 0 10px 4px #3498db'
    }

    const mouseOutBtn = (e) => {
        e.target.style.fontWeight = ''
        e.target.style.boxShadow = ''
    }

    return (
        <Box>
            {/* <ReactLink to="/event">
                <Box 
                    display="flex" 
                    flexDirection="column" 
                    alignItems="left" 
                    justifyContent="center" 
                    style={{ width:'1920px', height: '165px', backgroundImage: 'url("/images/events/banner.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
                    sx={{ p: 10}}
                >
                    <span style={{ color: '#FFFFFF', fontSize: '20px', paddingBottom: '10px' }}>모아의 시작을 함께할 작가님을 찾습니다.</span>
                    <Box 
                        display="flex" 
                        flexDirection="row" 
                        alignItems="center" 
                        justifyContent="left" 
                    >
                        <span style={{ color: '#6F9BFF', fontSize: '50px', fontWeight: "bold"}}>스타터 작가</span>
                        <span style={{ color: '#FFFFFF', fontSize: '50px', fontWeight: "bold", paddingLeft: '10px', paddingRight: '20px' }} className={styles.starter_txt_mouse_over}>
                            신청하러 가기
                        </span>
                        <img alt="goEvent" src="/images/events/button_go_txt.png"/>
                    </Box>
                </Box>
            </ReactLink> */}
            {/* 1page */}
            <Box style={{ width:'1920px', height: '100vh', backgroundImage: 'url("/images/web-1.png")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                {show && <>
                <Box
                    display="flex" 
                    flexDirection="column" 
                    style={{ position: 'fixed', right: '175px', top: '60px'}}
                >
                    {/* ios 없어서 구글 마켓으로만 보내기 위해 주석 처리함 */}
                    <span onClick={downloadBtnClick} style={{cursor: 'pointer'}}><img alt="logo" src="/images/download_button.png" width={'169'} height={'65'}/></span>

                    {/* ios 없어서 구글 마켓으로만 보내기 위해 showBox 안보이고 바로 보냄. ios 개발되면 위에 주석 풀고 이건 지워야함 */}
                    {/* <Link href='https://play.google.com/store/apps/details?id=rp.project.mooa' target='_blank'>
                        <span><img alt="logo" src="/images/download_button.png" width={'169'} height={'65'}/></span>
                    </Link> */}
                </Box>
                {showBox &&
                <Box
                    display="flex" 
                    flexDirection="column" 
                    style={{ position: 'fixed', right: '180px', top: '130px'}}
                >
                    <Box
                        display="flex" 
                        flexDirection="column" 
                        alignItems="left"
                        justifyContent="center"
                        border="1px solid black"
                        p={2}
                        style={{ borderRadius: '20px' }}
                        width="200px"
                    >
                        <Link href="https://play.google.com/store/apps/details?id=rp.project.mooa" target='_blank' style={{ textDecoration: 'none', color: 'black' }}>
                            <Box display="flex" alignItems="center">
                                <img alt="logo" src="/images/icon_googleplay.png" width={'20'} height={'20'}/>
                                <span style={{fontSize: '13px', paddingLeft: '10px'}}>Google Play</span>
                            </Box>
                        </Link>
                        <Divider sx={{ height: 1.1, m: 1, marginLeft: '5px', marginRight: '5px' }} orientation="vertical" style={{ background: 'black' }} />
                        {/* <Link href="https://www.instagram.com/art___mooa/" target='_blank' style={{ textDecoration: 'none', color: 'black' }}> */}
                            <Box display="flex" alignItems="center">
                                <img alt="logo" src="/images/icon_appstore.png" width={'20'} height={'20'}/>
                                <span style={{fontSize: '13px', paddingLeft: '10px',}}>App Store 출시예정</span>
                            </Box>
                        {/* </Link> */}
                    </Box>
                </Box>
                }
                </>}
                
                <Box 
                    display="flex" 
                    flexDirection="column"
                    paddingLeft="130px"
                    paddingRight="190px"
                    paddingTop='90px'
                >
                    <span><img alt="logo" src="/images/mooa_logo_white.png" width={'170'} height={'169'}/></span>
                    <span style={{color: '#ffffff', fontSize: '77px', paddingLeft: "25px"}}>쉽고 빠른</span>
                    <span style={{color: '#ffffff', fontSize: '77px', paddingLeft: "25px"}}>미술품 거래는</span>
                    <span style={{color: '#ffffff', fontSize: '77px', paddingLeft: "25px"}}>모아</span>
                    {/* <span style={{color: '#ffffff', fontSize: '17px', paddingTop: '150px', paddingLeft: '1200px' }}>앱스토어 다운로드</span>
                    <Box 
                        display="flex" 
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        paddingRight='10px'
                    >
                        <span>
                            <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                                <img alt="logo" src="/images/googleplay.png" width={'202'} height={'87'}/>
                            </Link>
                        </span>
                        <span>
                            <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                                <img alt="logo" src="/images/appstore.png" width={'202'} height={'87'}/>
                            </Link>
                        </span>
                    </Box> */}
                </Box>
            </Box>
            {/* 2page */}
            <Box style={{ width:'1920px', height: '100vh', backgroundImage: 'url("/images/web-2-new.png")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} ref={ref}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    paddingTop='400px'
                    paddingLeft='900px'
                >
                    <span><img alt="logo" src="/images/mooa_logo_black.png" width={'90'} height={'89'} /></span>
                    {/* <span><img alt="logo" src="/images/mooa_logo_black.png" width={'90'} height={'89'} className={styles.rotate_img}/></span> */}
                    <span style={{fontSize: '39px', paddingLeft: '10px',}}>안녕하세요</span>
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>모두의 아트, 모아입니다.</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '20px', paddingBottom: '2px'}}>모아는 국내 아마추어 작가들의 작품을 사고팔 수 있는 플랫폼입니다.</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingBottom: '2px'}}>작품 판매 외에도 자신의 작품을 타인과 공유할 수 있으며</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>이를 하나의 컬렉션으로 만들어 수집할 수 있는 서비스를 제공합니다.</span>
                </Box>

            </Box>
            <Box style={{ width:'1920px', height: '100vh', backgroundImage: 'url("/images/web-3.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    paddingTop='500px'
                    paddingLeft='300px'
                >
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>손쉬운</span>
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>미술품 거래</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '20px', paddingBottom: '2px'}}>모아는 1:1 채팅을 지원하여</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingBottom: '2px'}}>판매자와 구매 희망자가 작품에 대해</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>편하게 이야기를 나눌 수 있도록 하였습니다.</span>
                </Box>
            </Box>
            <Box style={{ width:'1920px', height: '100vh', backgroundImage: 'url("/images/web-4.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    paddingTop='500px'
                    paddingLeft='1100px'
                >
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>취향을 담은</span>
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>나만의 컬렉션</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '20px', paddingBottom: '2px'}}>모아는 거래 외에도 [컬렉션] 기능을 지원합니다.</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingBottom: '2px'}}>누구나 원하는 작품을 스크랩하여 나만의 컬렉션을 제작할 수 있습니다.</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>만들어진 컬렉션은 다른 이용자들과 공유할 수 있습니다.</span>
                </Box>
            </Box>
            <Box style={{ width:'1920px', height: '100vh', backgroundImage: 'url("/images/web-5.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    paddingTop='120px'
                >
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>다양한 장르의 미술품</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '20px'}}>모아에는 회화, 동양화, 디지털 아트, 조소 및 공예,</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>포토그래피, 섬유예술 등 다양한 장르의 작품들이 있습니다</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px', paddingTop: '10px'}}>각 분야의 작품을 모아볼 수 있음은 물론 세부 필터를 더해</span>
                    <span style={{fontSize: '16px', paddingLeft: '10px'}}>보다 쉽게 작품을 검색할 수 있도록 하였습니다.</span>
                </Box>
            </Box>
            <Box style={{ width: '1920px', height: '1284px', backgroundImage: 'url("/images/web-6.jpg")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}}>
                <Box 
                    display="flex" 
                    flexDirection="column"
                    alignItems="left"
                    justifyContent="center"
                    paddingTop='650px'
                    paddingLeft='1050px'
                >
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>지금 모아에 접속해</span>
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>잠들어 있는 나의 작품을</span>
                    <span style={{fontSize: '39px', paddingLeft: '10px'}}>거래해 보세요.</span>
                </Box>
            </Box>
            {/* footer */}
            <Box style={{ width:'1920px', height: '400px', backgroundColor: '#353C46'}}>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    paddingLeft="10%"
                    paddingRight="10%"
                >
                    <img alt="logo" src="/images/mooa_logo_footer.png" width={'131'} height={'34'}/>
                    <span style={{color: '#ffffff', fontSize: '17px'}}>모두의 아트, 모아</span>
                </Box>
                <Divider sx={{ height: 2, m: 1, marginLeft: '10%', marginRight: '10%' }} orientation="vertical" style={{ background: '#B7B7B7' }} />
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>러닝포인트 | 대표 : 박태훈 | 사업자등록번호 : 515-81-56247</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='20px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>문의사항</span>
                    <span style={{color: '#B7B7B7', fontSize: '17px', paddingLeft: '10px'}}>oursartsmoah@gmail.com</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='20px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>서울특별시 금천구 가산디지털1로 205-15, 1007호</span>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <Link href="https://www.instagram.com/art___mooa/" target='_blank'>
                        <img alt="logo" src="/images/instagram_logo.png" width={'37'} height={'34'}/>
                    </Link>
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row"
                    paddingLeft="10%"
                    paddingRight="10%"
                    paddingTop='50px'
                >
                    <span style={{color: '#B7B7B7', fontSize: '17px'}}>©</span>
                    <span style={{color: '#B7B7B7', fontSize: '17px', paddingLeft: '5px'}}>MOOA</span>
                </Box>
            </Box>
        </Box>
    )
}
